import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { Toaster } from "react-hot-toast";


export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu />
        <div className="container-fluid  " >
          {this.props.children}
        </div>
        <Toaster
          position="top-center"
          containerStyle={{ top: 70 }}
          toastOptions={{ style: { fontSize: 20 } }}
          reverseOrder={true}
        />
      </div>
    );
  }
}
